import { render } from "./Ranks.vue?vue&type=template&id=044e3b04"
import script from "./Ranks.vue?vue&type=script&lang=js"
export * from "./Ranks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__